import { isDefined } from '@sgme/fp';
import type { FieldMetadata } from 'models/forms/fields';
import { useMemo } from 'react';

interface UseBatchFormNavLayerStateProps {
  metadata?: FieldMetadata;
  formStatus?: string;
}

export const useBatchFormNavLayerState = ({ metadata, formStatus }: UseBatchFormNavLayerStateProps) => {
  const isCellHidden = useMemo(() => isDefined(metadata) && metadata.isHidden, [metadata]);

  const isFormPricing = useMemo(() => formStatus === 'QUOTING', [formStatus]);

  const isModalField = useMemo(
    () => isDefined(metadata) && (metadata.type === 'ScheduleModalField' || metadata.type === 'DealSplitModalField'),
    [metadata],
  );

  const isCellEditable = useMemo(
    () => isDefined(metadata) && !metadata.isReadOnly && !isFormPricing,
    [metadata, isFormPricing],
  );

  const isCellDraggable = useMemo(() => {
    return isCellEditable && !isCellHidden && !isFormPricing && !isModalField;
  }, [isCellEditable, isCellHidden, isFormPricing, isModalField]);

  const isCellSelectable = useMemo(() => !isModalField, [isModalField]);

  return {
    isCellHidden,
    isFormPricing,
    isModalField,
    isCellEditable,
    isCellDraggable,
    isCellSelectable,
  };
};
